import { CarouselItem } from "@atoms/carousel-item";
import { Section } from "@atoms/section";
import { Typography } from "@atoms/typography";
import { List } from "@molecules/list";
import { ListItemText } from "@molecules/list-item-text";
import { Owners } from "@organisms/owners";
import { LayoutTemplate } from "@templates/layout";
import React, { FC, useMemo } from "react";
import { useTranslation } from "next-i18next";
import styled from "styled-components";
import { ContactArea } from "@templates/contact";

export const AboutTemplate: FC = () => {
  const { t } = useTranslation("about");

  const owners = useMemo(
    () => [
      {
        name: "Taylan",
        avatarStandard: "/images/taylan.jpg",
        avatarWebp: "/images/taylan.webp",
        aboutMe: t("about-taylan"),
      },
      {
        name: "Guillermo",
        avatarStandard: "/images/guillermo.jpg",
        avatarWebp: "/images/guillermo.webp",
        aboutMe: t("about-guillermo"),
      },
    ],
    [t]
  );

  return (
    <LayoutTemplate page="about-us">
      <CarouselItem
        imageStandard="/images/header_about.jpg"
        imageWebp="/images/header_about.webp"
      />
      <Section>
        <Typography variant="title1">{t("title")}</Typography>
        <Grid>
          <AboutUsContainer>
            <Typography variant="body1" paragraph>
              <NewlineText text={t("what-is-feeling-home")} />
            </Typography>
            <Typography variant="title2">{t("why-feeling-home")}</Typography>
            <List>
              <ListItemText>{t("we-love-mallorca")}</ListItemText>
              <ListItemText>{t("motivation")}</ListItemText>
              <ListItemText>{t("objective")}</ListItemText>
              <ListItemText>{t("special-relations-our-guests")}</ListItemText>
              <ListItemText>{t("friendly")}</ListItemText>
            </List>
          </AboutUsContainer>
          <OfficeContainer>
            <OfficeImage
              src="/images/feelinghome_office.jpg"
              alt="Oficina de FeelingHome"
            />
          </OfficeContainer>
        </Grid>
      </Section>
    </LayoutTemplate>
  );
};

function NewlineText({ text }: { text: string }) {
  const newText = text.split("\n").map((str, index, array) => (
    <React.Fragment key={index}>
      {str}
      {index === array.length - 1 ? null : <br />}
    </React.Fragment>
  ));

  return <>{newText}</>;
}

const AboutUsContainer = styled(`div`)`
  flex: 1;
`;

const OfficeContainer = styled("div")`
  width: 100%;
  @media (min-width: 678px) {
    width: 40%;
  }
`;

const OfficeImage = styled("img")`
  display: block;
  width: 100%;
  height: auto;
`;

const Grid = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (min-width: 678px) {
    flex-direction: row;
  }
`;
